export class PatientsRoutingRouteNames {
    public static readonly Animal = 'animal';
}
